import React from "react";
import { motion } from "framer-motion";
import { BRAND } from "@/lib/site";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="surface-canvas pt-[96px] pb-12 sm:pt-[120px] sm:pb-16 md:pt-[140px] md:pb-20"
    >
      <div className="mx-auto max-w-[1200px] px-4 sm:px-6">
        {/* Editorial Masthead Center Stack */}
        <div className="flex flex-col items-center text-center">
          <motion.h1
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="text-display max-w-[840px] text-[#222222]"
          >
            We build the software that scales. We train the engineers who ship it.
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
            data-testid="hero-sub"
            className="mt-4 sm:mt-6 text-body-editorial max-w-[640px] text-[#222222]"
          >
            {BRAND.name} is a hybrid studio. We ship production software for
            teams that care about architecture, while training the next generation
            of builders on the very same live systems.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="mt-6 sm:mt-8 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 w-full sm:w-auto"
          >
            <a
              href="#services"
              data-testid="hero-primary-cta"
              className="btn-primary-action w-full sm:w-auto"
            >
              Explore our services
            </a>
            <a
              href="#contact"
              data-testid="hero-secondary-cta"
              className="btn-secondary-action w-full sm:w-auto"
            >
              Start a project
            </a>
          </motion.div>
        </div>

        {/* Full-width Media Block: 1200px max-width, 12px radius, 1px border */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="mt-10 sm:mt-14 md:mt-16"
        >
          <figure
            data-testid="hero-image"
            className="media-frame relative aspect-[16/10] sm:aspect-[16/9] md:aspect-[21/9] w-full"
          >
            <img
              src="https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=2400&q=80"
              alt="Innovate IT Solutions engineering team in session"
              className="h-full w-full object-cover"
              loading="eager"
            />
          </figure>
        </motion.div>
      </div>
    </section>
  );
};
